import { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import Fallback from "components/Fallback";

const RequireAuth = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (!initialized) return;

    if (
      !keycloak?.authenticated &&
      !window.location.pathname.includes("/oidc_callback")
    ) {
      keycloak.login({
        redirectUri: `${window.location.origin}/oidc_callback`,
        scope: "openid",
      });
    }
  }, [initialized, keycloak]);

  if (!initialized) return <Fallback />;

  if (
    !keycloak?.authenticated &&
    window.location.pathname.includes("/oidc_callback")
  ) {
    return <Fallback />;
  }

  return children;
};

export default RequireAuth;
